/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { CtaAction, type YourRentalCtaDto } from '@zg-rentals/ts-your-rental-api-client';

type UseYourRentalCtaHandlerProps = {
  listingAlias?: string;
  isInMobileWebView: boolean;
};

const extractPropertyConditionId = (url: string): string | null => {
  const match = url.match(/\/property-condition\/report\/([^/?]+)/);
  return match ? match[1] : null;
};

export const useYourRentalCtaHandler = ({ listingAlias, isInMobileWebView }: UseYourRentalCtaHandlerProps) => {
  return useCallback(
    (cta: YourRentalCtaDto) => {
      if (!isInMobileWebView) {
        return false;
      }

      switch (cta.action) {
        case CtaAction.SEND_MESSAGE: {
          // TODO: Get conversationId from api
          const conversationId = '';
          if ((window as any).ZMOB_nativeAPI?.seeMessages) {
            (window as any).ZMOB_nativeAPI.seeMessages(conversationId, listingAlias);
            return true;
          }
          return false;
        }

        case CtaAction.PCR_DASHBOARD_ACTION: {
          const propertyConditionId = extractPropertyConditionId(cta.url);
          if (propertyConditionId && (window as any).ZMOB_nativeAPI?.propertyConditionsCardClicked) {
            (window as any).ZMOB_nativeAPI.propertyConditionsCardClicked(propertyConditionId, cta.url);
            return true;
          }
          return false;
        }
        default:
          return false;
      }
    },
    [listingAlias, isInMobileWebView],
  );
};
